<template>
  <div class="flex h-screen text-white">
    <!-- Sidebar -->
    <sidebar-element
      v-if="!isApologyPage && !loading"
      class="h-screen sticky top-0"
    ></sidebar-element>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col overflow-y-auto">
      <!-- Navbar -->
      <navbar-element
        v-if="!isApologyPage && !loading"
        v-on:logout="handleLogout()"
      ></navbar-element>

      <!-- Loading Screen -->
      <loading-element v-if="loading"></loading-element>

      <!-- Page Content -->
      <router-view v-if="!loading"></router-view>

      <!-- Footer -->
      <footer-element v-if="!isApologyPage && !loading"></footer-element>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NavbarElement from "../components/NavbarElementUpdated.vue";
import FooterElement from "../components/FooterElementUpdated.vue";
import LoadingElement from "../components/LoadingElement.vue";
import SidebarElement from "@/components/SidebarElement.vue";

export default {
  components: {
    FooterElement,
    NavbarElement,
    LoadingElement,
    SidebarElement,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isApologyPage() {
      return this.$route.name === "Apology"; 
    },
  },
  methods: {
    handleLogout() {
      this.loading = true;
      this.$store.commit("UPDATE_USER", null);
      this.$store.commit("UPDATE_USERNAME", null);
      localStorage.removeItem("vuex");
      localStorage.removeItem("ballyboy-access-token");
      this.isLogout = false;
      this.$router.replace("/");

      setTimeout(() => {
        this.loading = false;
      }, 2000);
    },
  },
  mounted() {
    const accessToken = this.$route.query.accessToken;
    if (accessToken) {
      this.loading = true;
      axios
        .get(process.env.VUE_APP_BASE_API + "/api/user", {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((res) => {
          const user = res.data.user;
          const picUrl = `https://cdn.discordapp.com/avatars/${user.discordId}/${user.profileImage}.png`;

          localStorage.setItem("ballyboy-access-token", accessToken);
          this.$store.commit("UPDATE_USER", user);
          this.$store.commit("UPDATE_USERNAME", user.username);
          this.$store.commit("UPDATE_AVATAR", { avatar: picUrl });

          setTimeout(() => {
            this.loading = false;
            this.$router.replace("/profile");
          }, 2000);
        });
    }
  },
};
</script>

<style scoped></style>
